export class UI {
  dataUI: any;
}